export default {
    CustomerList: {
        ChooseCustomer: 'Seleziona il cliente',
    },

    Customer: {
        SafesOnline: 'Cassaforte online',
        CurrentBalance: 'Saldo corrente',
        DailySales: 'Vendite giornaliere',
        ActiveWarnings: 'Avvisi attivi',
        Of: 'OF',
        In: 'IN',
        Branches: 'FILIALI',
    },

    Branch: {
        ExportTransactions: "Esegui transazioni",
        ManageOperators: "Gestione degli operatori",
        ShowOnMap: "Mostra sulla mappa",
        CurrentBalance: "Saldo corrente",
        DailySales: 'Vendite giornaliere',
        MainCurrency: 'Valuta principale',
        TransactionDays: 'Giorno di valuta'
    },

    BranchList: {
        Name: 'Nome',
        Status: 'Stato',
        BalanceAmount: 'Saldo',
        BalanceCurrency: 'Saldo corrente',
        LastBalance: 'Aggiornato',
        Branches: 'Filiali',
    },

    BranchListFilter: {
        Branches: 'Filiali',
        SearchCriteria: 'Cerca filiale...',
    },

    Chart: {
        Sales: 'Vendite',
        Pickup: 'Ritiri',
        Balance: 'Saldo',
        Difference: 'Differenza',
        Confirmed: 'Confermato',
        SalesBalancesAndPickups: 'Saldo versamenti e prelevamenti',
        NoDataAvailable: 'Nessun dato disponibile',
        SafebagBalance: 'Importo safabag',
        RecyclableBalance: 'Saldo residuo',
        ManualDepositBalance: 'Saldo versamento manuale',
        OverflowBalance: 'Limite del saldo superato'
    },

    ChartDenominations: {
        Deposited: 'Depositato',
        Recyclable: 'Disponibilità',
        Denominations: 'Denominazione',
        NoDataAvailable: 'Nessun dato disponibile'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Versamenti elaborati',
        UnprocessedSales: 'Versamenti non elaborati',
        SalesOut: 'Prelevamenti',
        SalesPerHour: 'Fattura oraria'
    },

    CustomerHeader: {
        ShowOnMap: 'Visualizza sulla mappa',
        Branches: 'Filiali',
        Branch: 'Filiale',
        ExportTransactions: 'Transazioni',
    },

    DeviceStatus: {
        AllOk: 'Tutto ok',
    },

    DeviceStatusList: {
        Safes: 'Casseforti',
    },

    ExportForm: {
        ExportTransactions: 'Esegui transazioni',
        Cancel: 'Cancellare',
        Export: 'Esportare',
        FromDate: 'Dal',
        Time: 'Ora',
        EndDate: 'Al'
    },

    ForgotPasswordForm: {
        EmailAddress: 'Indirizzo email',
        Submit: 'Invia e-mail',
        ErrorMessage: 'Non siamo riusciti a inviare la richiesta al server',
        ForgotHeader: 'Dimenticato la password?',
        ForgotText: 'Prego, inserisca la sua mail sotto e clicchi il tasto. Riceverà una e-mail con ulteriori istruzioni.',
        LoginLink: 'Torna al Login',
    },

    LoginPage: {
        LoginHeader: 'Benvenuto',
        LoginText: 'Acceda qui sotto utilizzando e-mail e password',
        LoginForgot: 'Dimenticato la password?',
        Username: 'Email',
        Password: 'Password',
        Login: 'Accesso'
    },

    ResetPasswordPage: {
        ResetHeader: 'Reimpostare password',
        ResetText: 'Inserire nuova password'
    },

    Drawer: {
        Dashboard: 'Pannello',
        SwitchCustomer: 'Cambio cliente',
        MyProfile: 'Profilo',
        Report: 'Rapporto',
        Logout: 'Disconnettere'
    },

    OperatorForm: {
        UserId: 'Nome utente (ID)',
        FirstName: 'Nome',
        LastName: 'Cognome',
        Pin: 'Pin',
        Save: 'Salvare',
        Delete: 'Elimina',
        Operator: 'Operatore'
    },

    OperatorList: {
        AddOperator: 'Aggiungi operatore',
        Operators: 'Operatori',
        Name: 'Nome',
    },

    Profile: {
        Profile: 'Profilo',
        Name: 'Nome',
        Language: 'Lingua',
        Password: 'Password',
        ConfirmPassword: 'Conferma password',
        Update: 'Aggiornare'
    },

    ResetPasswordForm: {
        NewPassword: 'Nuova password',
        ConfirmPassword: 'Conferma password',
        Submit: 'Sottoscrivi'
    },

    InviteUserForm: {
        InviteHeader: 'Utente invitato',
        InviteText: 'Prego compili il suo profilo e prema salva per poter accedere.',
        Name: 'Nome',
        Language: 'Lingua',
        NewPassword: 'Nuova password',
        ConfirmPassword: 'Conferma password',
        Submit: 'Salva'
    },

    TransactionList: {
        Type: 'Tipo',
        Operator: 'Operatore',
        When: 'Quando',
        Amount: 'Quantità',
        Currency: 'Valuta',
        Transactions: 'Transazioni',
        Device: 'Dispositivo',
        SalesDay: 'Giorno di versamento',
        HoverDeposit: 'Versamento',
        HoverSalesIn: 'Versamento',
        HoverSalesOut: 'Prelevamento',
        HoverManualDeposit: 'Deposito manuale',
        HoverCollection: 'Prelevamento / ritiro',
        HoverCollectionNotes: 'Ritiro banconote',
        HoverCollectionCoins: 'Ritiro Moneta',
        HoverCollectionEnvelope: 'Ritiro depositi manuali',
        HoverCollectionOK: 'Ritiro confermato',
        HoverCollectionNotesOK: 'Conferma ritiro banconote',
        HoverCollectionCoinsOK: 'Conferma ritiro moneta',
        HoverCollectionEnvelopeOK: 'Conferma ritiro depositi manuali',
        HoverCollectionNOK: 'Ritiro differenze',
        HoverCollectionNotesNOK: 'Ritiro di differenza banconote',
        HoverCollectionCoinsNOK: 'Ritiro di differenza moneta',
        HoverCollectionEnvelopeNOK: 'Ritiro di differenza depositi manuali',
        HoverDrain: 'Rimozione',
        HoverRefill: 'Riempimento',
        HoverExchange: 'Sostituzione',
        HoverExchangeIn: 'Sostituzione versamenti',
        HoverExchangeOut: 'Sostituzione prelevamenti',
        HoverCounterfeit: 'Falsi',
        HoverInternal: 'Transazione interna',
        HoverNOP: 'Nessuna funzione'
    },

    TransactionDayList: {
        Date: "Data",
        Sales: "Valuta",
        Pickup: "Ritiro",
        Balance: "Saldo",
        TransactionDays: "Giorno di  valuta"
    },

    TransactionDay: {
        Date: "Data",
        Sales: "Valuta",
        Pickup: "Ritiro",
        Balance: "Saldo",
        TransactionDays: "Giorno di  valuta",
        ExportTransactions: "Transazioni"
    },

    TransactionDatePicker: {
        Date: 'Data'
    },

    ReportForm: {
        Title: "Rapporti periodici",
        Enabled: 'Attivare la rapport periodico',
        ReportSaved: 'Rapporto salvato',
        NextExecution: 'Esecuzione del prossimo',
        Reports: 'Rapporti',
        Report: 'Rapporto',
        ReportTRANSACTION: 'Rapporto di transazione',
        ReportBALANCE: 'Rapporto sulle vendite',
        ReportOPERATOR: "Rapporto dell'operatore",
        ReportTypeCSV: 'CSV',
        ReportTypeEXCEL: 'Excel',
        ReportTypePDF: 'PDF',
        Execution: 'Esecuzione',
        ExecutionTypeMonth: 'Una volta al mese',
        ExecutionTypeWeekDay: 'In settimana',
        ExecutionDay: 'Giorno in mesi',
        ExecutionTime: 'Tempo di esecuzione',
        ExecutionTimePattern: '00:00',
        ExecutionWeekDayMONDAY: 'Lunedì',
        ExecutionWeekDayTUESDAY: 'Martedì',
        ExecutionWeekDayWEDNESDAY: 'Mercoledì',
        ExecutionWeekDayTHURSDAY: 'Giovedì',
        ExecutionWeekDayFRIDAY: 'Venerdì',
        ExecutionWeekDaySATURDAY: 'Sabato',
        ExecutionWeekDaySUNDAY: 'Domenica',
        Content: 'Contenuto',
        ContentTypeSinceLast: "Tutto dall'ultimo rapporto",
        ContentTypeRelative: 'Relativa',
        ContentRelativeType: 'Passato: ',
        ContentRelativeTypeDAY: 'Giorni',
        ContentRelativeTypeWEEK: 'Settimane',
        ContentRelativeTypeMONTH: 'Mesi',
        ErrorFieldRequired: 'Campo obbligatorio!',
        ErrorSelectAtLeastOneDay: 'Selezionare almeno un giorno.',
        ErrorFormat: 'Deve essere in questo format: 00:00',
        ErrorEnableAtLeastOneReport: 'Attivare almeno un rapporto',
        Update: 'Salvare'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/it.js